import request from "./../utils/request";

export function getVisitors(
    perPage = 25,
    page = 1,
    startDate = null,
    endDate = null,
    query = null,
    userId = null,
    point,
    description,
    homeSite,
    videoCall,
    lostChats,
    subjectId = null,
    refs = null,
) {
    const qs = {
        perPage: perPage,
        pageCount: page,
        dateBegin: startDate,
        dateEnd: endDate,
        query: query,
        userId: userId,
        subjectId,
        point,
        description,
        homeSite,
        videoCall,
        lostChats,
        refs
    };

    Object.keys(qs).forEach((key) => {
        if (!qs[key] || qs[key] == "null") {
            delete qs[key];
        }
    });

    return request.get("/conversations/history", {
        params: qs,
    });
}

export function getCustomerDomains() {
    return request.get("/conversations/customerDomains");
}

export function getBannedVisitors(perPage = 25, page = 1) {
    return request.get("/bannedVisitors/pagination", {
        params: {
            pageCount: page,
            perPage: perPage,
        },
    });
}

export function deleteBannedVisitor(id) {
    return request.post(`/visitors/${id}/unblock`);
}
